import React, { useEffect, useState } from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";
import useAxios from "axios-hooks";
import LoadingSpinner from "components/feedback/LoadingSpinner";
import OngoingSessionsTable from "../components/OngoingSessionsTable";

const ActiveSessionsPanel = ({ locationId }) => {
  const [ongoingSessions, setOngoingSessions] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const bgColor = useColorModeValue("gray.50", "gray.900");

  const ongoingUrl = `/api/chargingSession/ongoing/all`;

  const [{ data: ongoingData, loading: ongoingLoading }, executeOngoing] =
    useAxios({ method: "GET", url: ongoingUrl }, { manual: true });

  const fetchOngoingSessions = async () => {
    try {
      const response = await executeOngoing();
      const sessionsData = response?.data?.data || [];
      setOngoingSessions(Array.isArray(sessionsData) ? sessionsData : []);
      if (isInitialLoad) {
        setIsInitialLoad(false);
      }
    } catch (error) {
      console.error("Error fetching ongoing sessions:", error);
      setOngoingSessions([]);
    }
  };

  useEffect(() => {
    fetchOngoingSessions();

    // Poll every 10 seconds to keep ongoing sessions updated
    const pollInterval = setInterval(() => {
      // only poll if there is ongoing session

      fetchOngoingSessions();
    }, 10000);

    return () => clearInterval(pollInterval);
  }, []);

  if (ongoingLoading && isInitialLoad) {
    return (
      <Box bg={bgColor} pt={{ base: 5, md: 5 }} px={{ base: 2, md: 4 }}>
        <LoadingSpinner />
      </Box>
    );
  }

  return (
    <>
      {ongoingSessions && !isInitialLoad && (
        <Box bg={bgColor} pt={{ base: 5, md: 5 }} px={{ base: 2, md: 4 }}>
          <OngoingSessionsTable
            sessions={ongoingSessions}
            onRefresh={fetchOngoingSessions}
          />
        </Box>
      )}
    </>
  );
};

export default ActiveSessionsPanel;
